import React, { ReactElement } from 'react'
import { Chip } from '@mui/material'
import { ProgramLabelAssignmentRequest } from 'src/service/backend/api'
import { getTextLength } from 'src/service/utils/TextUtils'
import { TooltipWrapper } from 'src/ui-shared/base/button/Buttons'

export const displayProgramLabels = (
  programLabels: ProgramLabelAssignmentRequest[] | null | undefined,
): ReactElement[] => {
  const labelChips: string[] = []

  if (programLabels) {
    programLabels.map((label) => {
      if (label.name) {
        labelChips.push(label.name)
      }
    })
  }

  return labelChips.map((value, index) => {
    const showTooltip = getTextLength(value) > 10

    return (
      <TooltipWrapper showTooltip={showTooltip} title={value} key={index}>
        <Chip sx={{ margin: '2px', maxWidth: '80px' }} label={value} size={'small'} />
      </TooltipWrapper>
    )
  })
}
